(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = ! isLargeScreen && (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.lg).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.lg).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  const mainHeaderContainer = document.getElementById('main_header_id');
  const reducedSearch = document.querySelector('.reduced-search');
  /* const shopfiyHeaderContainer = document.querySelector('.cc-header--sticky'); */
  // const announcementLogContainer = document.querySelector('.sticky-header-logo');
  let lastScrollY = window.scrollY;
  let isHeaderVisible = true;

  /* console.log('SHopify_Header: ', shopfiyHeaderContainer); */

  /* window.addEventListener('scroll', function () {
    const currentScrollY = window.scrollY;

    if (window.innerWidth > 1024) {
      if (currentScrollY > 100 && currentScrollY > lastScrollY) {
        // Scrolling down
        if (isHeaderVisible) {
          mainHeaderContainer.classList.remove('search-is-collapsed');
          mainHeaderContainer.classList.add('search-is-visible');
          mainHeaderContainer.classList.add('reduced-header');
          reducedSearch.style.left = '0%';
          isHeaderVisible = false;
        }
      } else if ((currentScrollY < lastScrollY && lastScrollY - currentScrollY > 10) || currentScrollY < 50) {
        // Scrolling up and has scrolled up at least 10px
        if (!isHeaderVisible) {
          mainHeaderContainer.classList.remove('reduced-header');
          mainHeaderContainer.classList.add('search-is-collapsed');
          mainHeaderContainer.classList.remove('search-is-visible');
          reducedSearch.style.left = '-100%';
          isHeaderVisible = true;
        }
      }

      // Update the last scroll position
      lastScrollY = currentScrollY;
    }
  }); */

  } catch(e) { console.error(e); }
})();
})();
